<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-plus-square"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Cancel"
    :submitTitle="submitTitle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <FormRow label="Blank Info">
        <FormInputText v-model="blankUserInfo" placeholder="Details" note="Additional info for the blank panel" />
      </FormRow>
      <FormRow label="Blank Height">
        <FormInputText type="number" addon="mm" v-model="blankHeight" />
      </FormRow>
      <FormRow label="Blank Width">
        <FormInputText type="number" addon="mm" v-model="blankWidth" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'


export default {
  name: 'BlankEditDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    sheetWidth: Number,
    sheetHeight: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      form: {},
      submitting: false,

      blankPanelUUID: '',
      blankUserInfo: '',
      blankWidth: 0,
      blankHeight: 0
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Sheet Blank' : 'Edit Sheet Blank'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    blankSizeTooLarge() {
      if(this.blankHeight >= this.sheetHeight && this.blankWidth >= this.sheetWidth && this.blankWidth >= this.sheetHeight && this.blankHeight >= this.sheetWidth)
        return true

      return false
    },
    blankSizeTooSmall() {
      if(this.blankHeight <= 0 || this.blankWidth <= 0)
        return true

      return false
    }
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      if(this.isCreateMode)
        this.blankPanelUUID = uuidv4()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()

      if(this.blankSizeHasError) {
        this.form.errorMessage = 'Blank size is larger then sheet'
        return
      }
      if(this.blankSizeTooSmall) {
        this.form.errorMessage = 'Blank size is too small'
        return
      }
      if(!this.blankUserInfo) {
        this.form.errorMessage = 'Info must be set'
        return
      }

      this.modalClosed({
        blankPanelUUID: this.blankPanelUUID,
        userInfo: this.blankUserInfo,
        width: this.blankWidth,
        height: this.blankHeight
      })
      this.hide()
    },
  }
}
</script>